  var ele = {
    $feuturedCollection: $('#shopify-section-featured-collections'),
  };

  var isFlickity;

  function enableFlickity() {
    if($(window).width() < 750){
      ele.$feuturedCollection.find('.grid__collection').flickity();
      isFlickity = true;
    } else {
      if ( isFlickity ) {
        ele.$feuturedCollection.find('.grid__collection').flickity('destroy');
      }
    } 
  }

  window.onload = function (event) {
    enableFlickity();
  };

  $(window).resize(function () {
    enableFlickity();
  });